import React, { useEffect } from "react";
import "./style.scss"
import { FaRankingStar } from "react-icons/fa6";
import { Formatter } from "utils/formatter";
import { useState } from "react";
import { Button, Rating } from "@mui/material";
import { getBestRatingBook } from "services/user/bookService";
import { useNavigate } from "react-router-dom";
const Ranking = () => {
    const [activeTabs, setActiveTabs] = useState(0);
    const [bestRatingBook, setBestRatingBook] = useState([]);
    const navigate = useNavigate()

    useEffect(() => {
        const fetchBestRatingBook = async () => {
            const response = await getBestRatingBook();
            if (response && response.data) {
                console.log(response.data);
                setBestRatingBook(response.data.slice(0, 5));;
            }
        };
        fetchBestRatingBook();
    }, []); 
    

    return (
        <div className="ranking">
            <div className="container">
                <div className="card rankingCard">
                    <div className="rankingHeader d-flex align-items-center">
                        <FaRankingStar/>
                        <h4>Bảng xếp hạng</h4>
                    </div>
                    <div className="rankingTabs mt-3">
                        <ul className="list list-inline d-flex">
                            <li className="list-inline-items">
                            <Button
                                className={`${activeTabs === 0 && "active"}`}
                                onClick={() => {
                                    setActiveTabs(0);
                                }}
                            >
                                Đánh giá
                            </Button>
                            </li>
                            {/* <li className="list-inline-items">
                            <Button
                                className={`${activeTabs === 1 && "active"}`}
                                onClick={() => {
                                    setActiveTabs(1);
                                }}
                            >
                                Yêu thích 
                            </Button>
                            </li> */}
                        </ul>
                    </div>

                    <div className="booksInfo">
                        {bestRatingBook.map((book, index) => {
                   
                            const rankingClass = index < 5 ? `number${index + 1}` : '';

                            return (
                                <>
                                    <div key={book.id} className={`bookCard d-flex `}
                                    onClick={() => navigate((`/details/${book.slug}`))}>
                                        <div className={`rankingNumber col-lg-1 ${rankingClass}`}>
                                            <h1>{index + 1}</h1>
                                        </div>
                                        <div className="bookImage col-lg-1">
                                            <img src={book.imageLink} alt={book.title} />
                                        </div>
                                        <div className="bookInfo col-lg-10">
                                            <h4 className="me-3">
                                                {book.title}
                                                <Rating
                                                    className="hi ms-3"
                                                    name="read-only"
                                                    value={book.rating}
                                                    precision={0.1}
                                                    readOnly
                                                    size="large"
                                                />
                                            </h4>

                                            <span>Lượt bán: </span>
                                            <span>{book.soldQuantity}</span>
                                            
                                            <br />
                                            <span className="curPrice_ranking text-danger">
                                                {Formatter(book.discountPrice)}
                                            </span>
                                            <span className="oriPrice_ranking">
                                                {Formatter(book.originalPrice)}
                                            </span>
                                        </div>
                                    </div>

                                    <hr/>
                                </>
                            );
                        })}

                    </div>
                </div>
            </div>
        </div>
    );
}

export default Ranking;